import { SearchCheckList } from "../../ui";

export default function FilterUI({
  label,
  options = [],
  selected = [],
  onChange,
  getLabel,
  getValue,
  single = false,
  fullWidth=""
}) {
  const mappedOptions = options.map((item) => ({
    label: getLabel ? getLabel(item) : String(item),
    value: getValue ? getValue(item) : item,
  }));

  const handleChange = (values) => {
    if (!single) {
      onChange(values);
      return;
    }

    const lastValue = values[values.length - 1];

    onChange(lastValue ? [lastValue] : []);
  };

  return (
    <SearchCheckList
      options={mappedOptions}
      selected={selected}
      onChange={handleChange}
      placeholder={label}
      fullWidth={fullWidth}
    />
  );
}